<script>
import { mapGetters } from "vuex";
import moment from "moment";
import * as Helper from "@/modules/helper/index";
export default {
  props: {
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    addDays: {
      type: Number,
      default: ""
    },
    allowOnlyFutureDates: {
      type: Boolean,
      default: false
    },
    date: {
      type: String,
      default: ""
    },
    defaultValue: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: ""
    },
    value: {
      type: String,
      default: null
    },
    errorMessage: {
      type: String,
      default: "" // default
    }
  },
  data() {
    return {
      calenderelement: null
    };
  },
  computed: {
    ...mapGetters(["language", "resource"]),
    calendarId() {
      return "calendar-" + this.index;
    },
    defaultDate() {
      let Date;
      if (this.defaultValue === "current") {
        Date = Helper.ConvertToMyZone();
      } else if (this.defaultValue === "addDays") {
        Date = Helper.ConvertToMyZone();
        Date = Date.add(this.addDays, "d");
      } else if (this.defaultValue === "date") {
        Date = Helper.ConvertToMyZone(this.date);
      } else {
        Date = null;
      }
      return Date;
    },
    defaultCalendarValue() {
      if (this.value !== null) {
        return Helper.FormattedDateDDMMMMYY(this.value)
      }
    },
    IsNullOrEmptyErrorMessage() {
      if (this.required && !Helper.IsNullOrEmpty(this.value)) {
        return true;
      }
    }
  },
  created () {
    if(this.defaultCalendarValue){
      this.$emit("propChange", {
      value: this.defaultCalendarValue
    });
    }
  },
  mounted() {
    this.createDatecalendar();
  },
  beforeDestroy() {
    if (this.calenderelement.modal) {
      this.calenderelement.modal.close();
    }
  },
  watch: {
    defaultValue: function(value, oldvalue) {
      if (value !== oldvalue && this.calenderelement) {
        this.calenderelement.destroy();
        this.calenderelement = null;
      }
      this.createDatecalendar();
    },
    addDays: function(value, oldvalue) {
      if (value !== oldvalue && this.calenderelement) {
        this.calenderelement.destroy();
        this.calenderelement = null;
      }
      this.createDatecalendar();
    },
    date: function(value, oldvalue) {
      if (value !== oldvalue && this.calenderelement) {
        this.calenderelement.destroy();
        this.calenderelement = null;
      }
      this.createDatecalendar();
    }
  },
  methods: {
    createDatecalendar() {
      let $this = this;
      if (this.calenderelement === null) {
        this.calenderelement = this.$f7.calendar.create({
          inputEl: "#" + this.calendarId,
          openIn: "customModal",
          header: true,
          footer: true,
          routableModals: false,
          value: this.setDefault(),
          disabled: {
            to: this.setDisabledates()
          },
          dateFormat: "dd MM yyyy",
          on: {
            change: function(calendar, values, displayValue) {
              let date = moment(values[0]).format("YYYY-MM-DD"); // YYYY-MM-DD
                $this.$emit("propChange", {
                  value: date
                });
            },
            close: function(calendar) {
              if(calendar.value) {
                let date1 = moment(String(calendar.value[0])).format("YYYY-MM-DD"); // YYYY-MM-DD
                $this.$emit("propChange", {
                  value: date1
                });
              }
            }
          }
        });
      }
    },
    setDefault() {
      if (this.defaultDate === null) {
        return "";
      } else {
        let defaultdt = moment(this.defaultDate);
        let d = [];
        d.push(defaultdt);
        return d;
      }
    },
    setDisabledates() {
      let date;
      if(this.allowOnlyFutureDates && this.defaultDate === null) {
         date = Helper.ConvertToMyZone();
        date = date.add(-1, "d");
      } else if(this.allowOnlyFutureDates) {
        date = new Date(this.setDefault()) - 1
      } else {
        date = new Date(1900, 0, 1)
      }
      return date
    }
  }
};
</script>

<template>
  <f7-list class="list-block inputs-list">
    <f7-list-item class="input-wrapper">
      <f7-label class="label-color">{{label}}</f7-label>
      <f7-input  type="text"  :placeholder="placeholder" v-model="defaultCalendarValue"  :id="calendarId" class="input-value-color" :readonly="true" />
      <!-- <f7-input type="text" :calendar-params="{ openIn: 'customModal'}" :placeholder="placeholder" id="demo-calendar-modal" :id="calendarId" class="input-value-color"></f7-input> -->
      <!-- <span v-if="!IsNullOrEmptyErrorMessage" class="color-red">{{errorMessage}}</span> -->
      <div v-if="!IsNullOrEmptyErrorMessage" class="color-red">{{errorMessage}}</div>
    </f7-list-item>
  </f7-list>
</template>

<style scoped>
  .list {
    margin: 15px 0;
  }
  .item-label {
    line-height: 15px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/stacked-elements/form-control/Calender.vue